"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgThumbsUp(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M13.223 0c.84 0 1.751.355 2.307.824l.056.046c.384.344.73 1.12.948 1.923.222.822.331 1.743.23 2.259l-.565 2.84h4.076c1.546 0 3.281.734 3.281 2.55v.424c0 .394-.053.746-.173 1.048.395.45.617 1.017.617 1.624v2.003c0 .597-.226 1.124-.636 1.549.14.363.188.795.188 1.257v.49c0 .63-.248 1.238-.786 1.67l-.29.2c.049.29.038.584.038.875 0 2.056-1.664 2.3-3.274 2.3h-7.526c-1.246 0-2.472-.366-3.405-1.23l.092.08v.003l-.093-.001v.315a.831.831 0 01-.717.827l-.103.006H2.472C.72 23.882 0 22.858 0 21.172v-9.514c0-1.722.747-2.669 2.512-2.669h.032l4.553.027 3.71-4.702.614-3.115c.04-.222.142-.425.285-.593C12.08.175 12.634 0 13.223 0zM2.535 10.518h-.023c-.929 0-1.007.279-1.007 1.14v9.514c0 .463.079.831.21.985.146.171.537.196.757.196h4.261v-11.81l-4.198-.025zM13.223 1.53c-.17 0-.285.03-.344.057l-.596 3.028-.072.366-.23.29-3.58 4.537v10.861l.921.853c.686.635 1.563.807 2.23.83l.162.002h7.526c1.768 0 1.768-.307 1.768-.771v-.148c.002-.184.003-.359-.016-.47l-.163-.973.805-.552.23-.159a.557.557 0 00.183-.443v-.49c0-.417-.053-.62-.085-.702l-.354-.921.682-.706a.64.64 0 00.205-.477v-2.003c0-.224-.08-.429-.236-.608l-.622-.71.351-.88c.023-.06.063-.2.063-.474v-.424c0-1.01-1.704-1.02-1.776-1.02H14.36l.364-1.832.564-2.84c.03-.163 0-.79-.205-1.552-.18-.661-.402-1.066-.494-1.18l-.011-.01L14.566 2c-.27-.228-.832-.47-1.343-.47z"
  }));
}

var _default = SvgThumbsUp;
exports.default = _default;